import {Component, OnInit, signal} from "@angular/core";
import {User} from "../classes/user.class";
import {CustomerArea} from "../classes/customerarea.class";
import {AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators} from "@angular/forms";
import {UserService} from "../services/user/user.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {CordovaService} from "../cordova.service";
import {CustomerAreaService} from "../services/consumer-area/customer-area.service";
import {ConfirmDialogService} from "../services/confirm-dialog-service/confirm-dialog.service";
import {RequiredRule} from "./profile.required-rules";
import {Utils} from "../utils.class";
import {CodaltComponent} from "../codalt.component";
import {TwoFactorService} from '../services/two-factor.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatError,
        MatCheckbox,
        MatLabel,
        MatButton
    ]
})
export class ProfileComponent extends CodaltComponent implements OnInit {

    readonly saving = signal<boolean>(false);
    readonly user = signal<User>(null);
    readonly customerAreas = signal<CustomerArea[]>(null);
    readonly groups = signal<any>(null);
    readonly form = signal<FormGroup<{
        name: FormControl<string>,
        notifications: FormControl<number>,
        email: FormControl<string>,
        change_pass: FormControl<boolean>,
        current_password: FormControl<string>,
        password: FormControl<string>,
        passwordconf: FormControl<string>,
    }> | null>(null);

    readonly sending2faEmail = signal<boolean>(false);

    constructor(
        private userService: UserService,
        private route: ActivatedRoute,
        private cordovaService: CordovaService,
        private customerAreaService: CustomerAreaService,
        private confirmDialogService: ConfirmDialogService,
        private twoFactorService: TwoFactorService,
        private router: Router
    ) {
        super();
    }

    get password() {
        return this.form().value.password;
    }

    setup2Fa() {
        this.sending2faEmail.set(true);
        this.twoFactorService.setupEmail().subscribe(() => {
            this.sending2faEmail.set(false);
            this.confirmDialogService.confirm('Tweestapsverificatie instellen',
                `Open de link in de zojuist gestuurde email om tweestapsverificatie in te stellen.`,
                'Oké', null).then(() => {

            }, () => {
            });
        });
    }

    ngOnInit() {
        this.userService.getCurrentUser().then(user => {
            this.user.set(user);
            this.setFormGroup(this.user());
        });
    }

    save() {
        Utils.triggerValidation(this.form());
        if (this.form().valid) {
            const user = JSON.parse(JSON.stringify(this.user()));
            Object.assign(user, this.form().value);
            this.saving.set(true);
            this.userService.saveProfile(user).then(response => {
                this.saving.set(false);
                this.router.navigate([`/`]);
            }, error => {
                this.saving.set(false);
                this.confirmDialogService.confirm('Er ging iets fout', error['error']['error']['errormessage']);
            });
        }
    }

    matchFieldValidator(matchField: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (this.form()) {
                const toValue = this.form().controls[matchField].value;
                const equal = toValue === control.value;
                return equal ? null : {'matchField': true};
            }
            return null;
        };
    }

    private setFormGroup(user: User) {
        this.form.set(
            new FormGroup({
                name: new FormControl(user.name, [Validators.required, Validators.minLength(3)]),
                notifications: new FormControl(user.notifications),
                email: new FormControl(user.email, [Validators.required, Validators.email]),
                change_pass: new FormControl(false),
                current_password: new FormControl('', RequiredRule(this)),
                password: new FormControl('',
                    [
                        Validators.minLength(7),
                        Validators.pattern(/^(?=.*[!@#$&*0-9A-Z].*[!@#$&*0-9A-Z]).*$/)
                    ]),
                passwordconf: new FormControl('', [
                    this.matchFieldValidator('password')
                ])
            })
        );

    }

}
